import { render, staticRenderFns } from "./CollapseTable.vue?vue&type=template&id=45fb08ae&"
import script from "./CollapseTable.vue?vue&type=script&lang=js&"
export * from "./CollapseTable.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports